module.exports = __webpack_public_path__ + "img/treppenaufgang.a5da17cc.jpg";